import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import Section9B from "./Section9B";

const Section9A = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: -3, sm: 6, md: 8 },
        px: { xs: 3, sm: 4, md: 6 },
        display: { xs: "flex", md: "none" },
        flexDirection: "column",
        alignItems: "center",
        // fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Heading */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: "100%",
          maxWidth: "1200px",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", sm: "90%", md: "80%" },
          }}
        >
          <Box
            sx={{
              width: "6px",
              height: { xs: "22px", sm: "36px", md: "30px" },
              backgroundColor: "#054E91",
              borderTopRightRadius: "6px",
              borderBottomRightRadius: "6px",
              mr: 2,
            }}
          />
          <Typography
            variant="h4"
            sx={{
              fontSize: {
                xs: "22px",
                sm: "26px",
                md: "30px",
                lg: "34px",
              },
              color: "#054E91",
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 600,
              letterSpacing: "0.5px",
              textAlign: "left",
              mb: { xs: 1.2, sm: 0 },
              mt: { xs: 0, sm: 0 },
            }}
          >
            Backed by
          </Typography>
        </Stack>
      </Stack>

      {/* Description */}
      <Typography
        sx={{
          fontSize: {
            xs: "15px",
            sm: "17px",
            md: "18px",
          },
          lineHeight: { xs: 1.6, sm: 1.85, md: 1.7 },
          fontFamily: "'Inter', sans-serif",
          color: "text.secondary",
          wordSpacing: "0.15em",
          letterSpacing: "0.3px",
          display: {
            xs: "block",
            sm: "none",
          },
          textAlign: "left",
          mt: { xs: 0.5, sm: 1.2 },
          mb: { xs: 3, sm: 3, md: 2, lg: 2 },
          maxWidth: "94%",
        }}
      >
        Trusted by institutions, accelerators, and innovation platforms that
        believe in our journey and support our mission.
      </Typography>

      {/* Content */}
      <Box sx={{ width: "100%", mt: 4 }}>
        <Section9B />
      </Box>
    </Box>
  );
};

export default Section9A;
